export default __webpack_public_path__ + "media/images/react_icons/calendar-grey-74d1c5c11250cca920763fac0223cb32.svg";